
import { css } from 'lit';
export default css`
@media (min-width: 1024px) {.cta-links {
    display: flex;
  }.cta-links {
    justify-content: flex-end;
  }.cta-links {
    padding-top: 1.25rem;
  }
}.cta-links__item {
  padding-top: 0.75rem;
}.cta-links__item {
  line-height: 1.25rem;
}@media (min-width: 1024px) {.cta-links__item {
    display: inline-block;
  }
}@media (min-width: 1024px) {.cta-links__item {
    padding-top: 0px;
  }
}@media (min-width: 1024px) {.cta-links__item {
    padding-left: 1.5rem;
  }
}.cta-links__item:first-child {
    /* First element is mis-aligned with others since it has no icon. */
    padding-top: 6px;
  }@media (min-width: 1024px) {.cta-links__item:not(:last-child) {
    border-right-width: 1px;
  }
}@media (min-width: 1024px) {.cta-links__item:not(:last-child) {
    --tw-border-opacity: 1;
    border-color: rgba(232, 194, 255, var(--tw-border-opacity));
  }
}@media (min-width: 1024px) {.cta-links__item:not(:last-child) {
    padding-right: 1.5rem;
  }
}
`;